// extracted by mini-css-extract-plugin
module.exports = {"report":"style__report__5HyPv","table":"style__table__L1AB5"};